const authApi = {
    login: 'auth/login',
    logout: 'auth/logout',
    guest_user_flow: "auth/guest-user-flow",
    terms_and_condition: "auth/terms-and-condition"
  };
  
  export { authApi };